export default __webpack_public_path__ + "static/media/slide3.544de1a8.png";